import CountryDetail from './CountryDetail';

export default CountryDetail;



// WEBPACK FOOTER //
// ./src/scenes/Countries/CountryDetail/index.ts